export default "__VITE_ASSET__C$1L5GIT__"